import React from "react";
import Icon_Plus from '../../../assets/icons/plus.png'
import Icon_Close from '../../../assets/icons/icon_close.svg'

interface Props {
  module1: any;
  module2: any;
  module3: any;
  module4: any;
  modules: any;
  availableTypologies: any;//array
  totalModules: number;
  activeGroup: number,
  currentModule: any;
  setCurrentModule: (value: any) => void;
  setActiveGroup: (value: number) => void;
}

const Module: React.FC<Props> = ({ module1, module2, module3, module4, totalModules, availableTypologies, activeGroup, modules, currentModule, setCurrentModule, setActiveGroup}) => {
  
  const [showOptions, setShowOptions] = React.useState(false);
  const [enabled, setEnabled] = React.useState(true);
  const [options, setOptions] = React.useState([]);

  const GroupClicked = () => {
    if(!enabled)
      return;
    if(currentModule)
      return;
    setActiveGroup(modules.index);
    setShowOptions(true);
  };

  const ModuleSelected = (value: any) => {
    if(!enabled)
      return;
    setCurrentModule(value);
    setActiveGroup(-1);
    setShowOptions(false);
  };

  const ResetModule = () => {
    if(!enabled)
      return;
    setCurrentModule(null);
    setActiveGroup(-1);
    setShowOptions(false);
  };

  React.useEffect(() => {
    setShowOptions(activeGroup === modules.index);
  }, [activeGroup, modules]);

  React.useEffect(() => {
    let enable = true;
    const options = JSON.parse(JSON.stringify(modules.options));

    CheckAllowedModules(options, availableTypologies, `module${modules.index}`);

    if(modules.index > 1){
      enable = enable && (module1);
      CheckUsedModules(options, module1);
    }
    if(modules.index > 2){
      enable = enable && (module2);
      CheckUsedModules(options, module2);
    } 
    if(modules.index > 3){
      enable = enable && (module3);
      CheckUsedModules(options, module3);
    }
    
    //console.log(`Module${modules.index}: ${enable}`)
    setEnabled(enable);
    setOptions(options);
    if(!enable){
      setShowOptions(false);
    }
  }, [module1, module2, module3, module4, modules, availableTypologies ]);

  const CheckUsedModules = (options: any, previousModule: any) => {
    if(!previousModule)
      return;
    for (const option of options){
      if(option.id === previousModule.id){
        option.taken = true;
      }
    }
  };

  const CheckAllowedModules = (options: any, availableTypologies: any, moduleName: string) => {
    for (const option of options){
      let taken = true;
      for (const available of availableTypologies){
        if(option.id.toLowerCase().includes(available[moduleName])){
          taken = false;
          break;
        }
      }
      option.taken = taken;
    }
  }

  return (
    <div className={`tour-sidebar-module ${activeGroup === modules.index ? 'selected':''}`}>
      <div className={`tour-sidebar-module-box ${currentModule || !enabled ? 'disabled':''}`} onClick={GroupClicked}>
        { currentModule ? 
          <img className={`tour-sidebar-module-image`} src={currentModule.image} draggable={false} alt=''/>
          :
          <img className={`tour-sidebar-module-add`} src={Icon_Plus} draggable={false} alt=''/>
        }
        {currentModule && <img className={`tour-sidebar-module-close`} src={Icon_Close} draggable={false} alt='' onClick={(e) => {e.preventDefault(); e.stopPropagation(); ResetModule()}}/>}
      </div>
      
      {showOptions && 
        <div className='tour-sidebar-module-options-pivot'>
          <div className={`tour-sidebar-module-options ${modules.index - 1 > 0.49 * totalModules ? 'right':''}`}>
            {
              options.map( (option: any, index: number) => 
                <div key={option.value} className={`tour-sidebar-module-option ${!option.taken ? '':'disabled'}`} onClick={() => {if(!option.taken){ModuleSelected(option)}}}>
                  <div key={option.value} className={`tour-sidebar-module-option-text ${option.taken === true ? 'disabled':''}`}>{option.name}</div>
                </div>
              )
            }
          </div>
        </div>
      }
    </div>
  );
};

export default Module;